'use client';
import { DatePicker } from 'antd-v5';
import { useState } from 'react';
import dayjs from 'dayjs';
import FormErrorTips from '../comps/FormErrorTips';

export default function FormDate({ id, data, index, callback }: any) {
    const disabledDate = (current: any) => {
        return current && current < dayjs().startOf('day');
    };

    const [showError, setShowError] = useState(false);
    const changeHandle = (e: any) => {
        const val = dayjs(e).format('YYYY-MM-DD');
        callback(data, index, val === 'Invalid Date' ? undefined : val);
        if (data.isRequire && !val) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    };
    return (
        <div className={`form-common-content${showError ? ' form-common-show-error' : ''}`}>
            {data?.label && <label className="form-common-label">{data.label}</label>}
            <DatePicker
                className="form-common-date"
                onChange={changeHandle}
                placeholder={data.placeholder}
                suffixIcon={
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3.33325" y="5" width="13.3333" height="11.6667" rx="0.833333" stroke="#ADAFB3" strokeWidth="1.25" />
                        <path d="M6.66675 9.375H13.3334" stroke="#ADAFB3" strokeWidth="1.25" strokeLinecap="round" />
                        <path d="M6.66675 3.33325V5.83325" stroke="#ADAFB3" strokeWidth="1.25" strokeLinecap="round" />
                        <path d="M13.3333 3.33325V5.83325" stroke="#ADAFB3" strokeWidth="1.25" strokeLinecap="round" />
                    </svg>
                }
                disabledDate={disabledDate}
                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
            />
            <FormErrorTips data={data} />
        </div>
    );
}
